import * as React from "react";

export const GuestFooter = () => (<p className="m-t"><small>Vitalograph Web Portal &copy; 2015 - 2025 Vitalograph Ltd</small></p>)
